import React, { useEffect, useState } from 'react'
import { History, Location } from 'history'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { Pagination } from 'antd'
import styled from 'styled-components/macro'
import { Col } from 'styled-bootstrap-grid'
import { getProfiles } from '../../features/profile/selectors'
import { ProfileActions } from '../../features/profile/actions'
import { Profile } from '../../features/profile/types'
import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { Title } from '../../components/Text'
import { ProfileItem } from './ProfileItem'
import { Row } from '../../components/Grid'

const StyledPagination = styled(Pagination)`
  margin: 20px 0;
  text-align: center;
`

type Props = {
  history?: History
  location: Location<{ showInDashboard?: boolean } | undefined>
}

export const Profiles = () => {
  const dispatch = useDispatch()
  const profiles = useSelector(getProfiles)
  const [offset, setOffset] = useState(0)
  const [total, setTotal] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    setTotal(1055)
  }, [])

  useEffect(() => {
    dispatch(ProfileActions.fetchAllProfiles(9, offset, 'CaldeTentazioni'))
  }, [dispatch, offset])

  const onPageChange = (page: number, pageSize: number | undefined) => {
    if (page && pageSize) {
      setOffset(page * pageSize)
      setCurrentPage(page)
    }

    // console.log(`page: ${page}, pageSize: ${pageSize}`)
  }

  return (
    <Page>
      <Layout>
        <Title size="XL">Profiles</Title>
        <Row>
          <Col md={12} alignSelf="center">
            <StyledPagination
              defaultCurrent={currentPage}
              pageSize={9}
              total={total}
              onChange={onPageChange}
              current={currentPage}
            />
          </Col>
        </Row>
        <Row>
          {profiles && _.map(profiles, (profile: Profile) => <ProfileItem key={profile.id} profile={profile} />)}
        </Row>
        <Row>
          <Col md={12} alignSelf="center">
            <StyledPagination
              defaultCurrent={currentPage}
              pageSize={9}
              total={total}
              onChange={onPageChange}
              current={currentPage}
            />
          </Col>
        </Row>
      </Layout>
    </Page>
  )
}
